{
  "invalidId": "Error: Invalid id",
  "localeNotSupported": "Error: Locale not supported",
  "invalidCountry": "Error: Invalid country",
  "invalidValue": "Error: Invalid value",
  "invalidState": "Error: Invalid state",
  "dataIntegrityViolation": "Error: Data integrity violation",
  "constraintViolation": "Error: Constraint violation",
  "skuAlreadyExists": "Error: SKU already exists",
  "duplicateLocales": "Error: Duplicate locales",
  "duplicateProductProperties": "Error: Duplicate product properties",
  "duplicateVariantProperties": "Error: Duplicate variant properties",
  "duplicatePrices": "Error: Duplicate prices",
  "general": "Error: something went wrong"
}
